import { Flex, Switch } from "antd";
import styled from "styled-components";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

export const StyledCheckoutSection = styled(Flex)`
    width: 100%;
    flex-direction: column;
    border-bottom: 1px solid #313131;
    gap: 4px;
    padding-bottom: 16px;
`;

export const StyledSectionTitle = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
`;

export const StyledSectionText = styled(PrimaryText)`
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
`;

export const StyledPaymentSwitch = styled(Switch)`
    background-color: #15325b !important;
    width: fit-content;

    .ant-switch-checked {
        background-color: #144848 !important;
    }
`;
